/* eslint-disable jsx-a11y/alt-text */
import React, { useRef, useState } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { logEvent, ITEM_CREATION_EVENTS } from "../../../../utils/amplitude";
import { Box, Typography, Switch } from "@mui/material";
import { NumericFormat } from "react-number-format";

import { ColDiv } from "../../../../components/misc/misc.styled";
import { FormTitleTypography } from "../itemCreation.styled";
import { Container } from "../../../../globalstyled";

import editIcon from "../../../../images/EditIcon.png";
import plusIcon from "../../../../images/PlusIcon.png";
import deleteIcon from "../../../../images/DeleteIcon.png";
import searchIcon from "../../../../images/searchIcon.png";

import { AppCSS, Spacer, TxtInput, ChkInputBox } from "../../../../components";
import { Lbl } from "../../../../components/labels";
import LeadsTableHeaderCard from "../../../../components/table/CustomTableHeaderCard";
import LeadsTableBodyCard from "../../../../components/table/CustomTableBodyCard";
import PaymentMethodWithoutHeader from "../../../../components/table/CustomTableBodyCardWithoutHeader";
import {
  PAYMENT_METHOD_TABLE_HEADER_LIST,
  PRODUCT_SYSTEM_TABLE_HEADER_LIST,
} from "../../../../contants/dashboardHeader";
import ProductDrawer from "../SideDrawer/index";
import TableViewDetails from "../../../../components/table/TableViewDetails";
import CancelAndSubmitButtons from "../ItemCreationComponent/SubmitAndCancelButton";
import { ProductSystem } from "../../../../redux/types/creation";
import { StandardIcon } from "../itemCreation.styled";
import { SelectInput } from "../../../../components/input/SelectInput";
import {
  PRIORITY_SELECT_INPUT_VALUE,
  PRODUCT_SYSTEM_DRAWER_DETAILS,
  PROJECT_DURATION_SELECT_INPUT_VALUE,
  PROJECTS_STEP,
  RANK_SELECT_INPUT_VALUE,
} from "../../../../contants/itemsCreation";
import SearchAndCreateComponent from "../ItemCreationComponent/SearchAndCreateComponent";
import SideDrawerHeader from "../SideDrawer/SideDrawerHeader";
import Pagination from "../ItemCreationComponent/Pagination";
import ViewRowDetailsDrawer from "../ItemCreationComponent/ViewFieldDetails";
import {
  CreateProductSystemInput,
  PaymentMethodInput,
  UpdateProductInput,
} from "../../../../types/graphQlQuery.interface";
import {
  useArchiveProductSystem,
  useCreateProductSystem,
  useUpdateProductSystem,
} from "../../../../apolloClient/hooks/itemCreation/createHooks";
import EmptyTable from "../../../../components/table/EmptyTable";
import { FileOpen } from "@mui/icons-material";
import { SFileUpload } from "../../../../components/input/input.styled";
import MaterialItemsDrawer from "../SideDrawer/index";
import { uploadImage } from "../../../../redux/api/common";
import { useCreateUploadUrl } from "../../../../apolloClient/hooks/general/createHook";
import PicturesTableWithoutHeader from "../../../../components/table/CustomTableBodyCardWithoutHeader";
import DisplayPhoto from "../ItemCreationComponent/DisplayPhoto";
import {
  getUploadFileDetails,
  validateFile,
} from "../../../../utils/uploadImage";
import ConfirmationDialog from "../../../../components/dialogue/ConfirmationDialog";

interface UserTableProps {
  productSystemData: ProductSystem[];
  refetchProduct?: Function;
  permissions: boolean;
}

export const ProductSystemsTable: React.FC<UserTableProps> = ({
  productSystemData,
  refetchProduct,
  permissions,
}) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage] = useState(8);
  const [keyword, setKeyword] = useState("");

  const [openDrawer, setOpenDrawer] = useState(false);
  const [openUpdateDrawer, setOpenUpdateDrawer] = useState(false);
  const [openPaymentMethodDrawer, setOpenPaymentMethodDrawer] = useState(false);
  const [openPaymentMethodFormDrawer, setOpenPaymentMethodFormDrawer] =
    useState(false);

  const inputRef = useRef<HTMLInputElement>(null);
  const [productSystemName, setProductSystemName] = useState<string>("");
  const [paymentName, setPaymentName] = useState<string>("");
  const [percentageOfProjectTotal, setPercentageOfProjectTotal] = useState<
    number | null
  >(null);
  const [fixedAmount, setFixedAmount] = useState<number | null>(null);
  const [paymentMethodData, setPaymentMethodData] = useState<
    PaymentMethodInput[]
  >([]);
  const [viewRowDetailsData, setViewRowDetailsData] =
    useState<ProductSystem | null>(null);

  const [checkPercentage, setCheckPercentage] = useState<boolean>(false);
  const [checkFixedAmount, setCheckFixedAmount] = useState<boolean>(false);
  const [projectsStep, setProjectsStep] = useState<number | null>(
    Number(PROJECTS_STEP[0].value)
  );
  const [priority, setPriority] = useState<number | null>(null);

  const [rank, setRank] = useState<number | null>(null);

  const [isMaterialSelectionRequired, setIsMaterialSelectionRequired] = useState<boolean>(true);
  const [isLaborSelectionRequired, setIsLaborSelectionRequired] = useState<boolean>(true);

  const [projectDuration, setProjectDuration] = useState<string | null>(null);

  const [isEditPaymentDetails, setIsEditPaymentDetails] =
    useState<boolean>(false);
  const [editPaymentIndex, setEditPaymentIndex] = useState<number | null>(null);

  const [openPhotoFormDrawer, setOpenPhotoFormDrawer] = useState(false);
  const [fileUrl, setFileUrl] = useState<string>("");

  const [photosDetails, setPhotosDetails] = useState<{
    fileName: string;
    fileUrl: string;
  }>({
    fileName: "",
    fileUrl: "",
  });
  const fileRef = useRef<HTMLInputElement>(null);
  const [uploadUrl, setUploadUrl] = useState<string>("");

  const { createProductSystem } = useCreateProductSystem();
  const { updateProductSystem } = useUpdateProductSystem();
  const { createUploadUrl } = useCreateUploadUrl();
  const { archiveProductSystem } = useArchiveProductSystem();

  const handleTogglePublish = async (row: ProductSystem) => {
    try {
      const success = await archiveProductSystem(row.id);
      if (success) {
        toast(`${row.name} ${row.archived ? "published" : "unpublished"}`, {
          type: row.archived ? "success" : "error",
        });
        logEvent(ITEM_CREATION_EVENTS.PRODUCT_SYSTEM_ARCHIVED, { system_id: row.id, system_name: row.name, is_archived: !row.archived, timestamp: new Date().toISOString() });
        refetchProduct();
      } else {
        toast(`Failed to Archive ${row.name}`);
      }
    } catch (error) {
      console.error("Error toggling publish status:", error);
      toast("An error occurred while updating publish status.", {
        type: "error",
      });
    }
  };

  const handlePhotoDrawerClose = () => {
    setOpenPhotoFormDrawer(false);
  };

  const handleDeleteDocument = (): void => {
    setPhotosDetails({
      fileName: "",
      fileUrl: "",
    });
  };

  const getUploadUrl = async () => {
    try {
      const file = fileRef.current?.files[0];
      if (!file) {
        throw new Error("No file selected");
      }

      const validationResult = validateFile(file);
      if (!validationResult.valid) {
        throw new Error(validationResult.error);
      }

      const imageType = validationResult.type!;
      const result = await getUploadFileDetails({
        createUploadUrl,
        contentType: imageType,
      });
      setUploadUrl(result.url);
      setFileUrl(result.fileName);
    } catch (err) {
      console.error("Error getting upload url ", err);
      toast("Error getting upload url", {
        type: "error",
        position: "top-left",
        className: "toast-message",
      });
      setUploadUrl("");
      setFileUrl("");
    }
  };

  const handleSubmitImage = async () => {
    const file = fileRef.current?.files[0];
    const fileName = file?.name;
    if (!file) {
      toast("An image have not been selected", {
        type: "error",
        position: "top-left",
        className: "toast-message",
      });
      return;
    }

    try {
      const result = await uploadImage(uploadUrl, file);
      if (result.success) {
        setPhotosDetails({ fileName: fileName, fileUrl: fileUrl });
        setOpenPhotoFormDrawer(false);
        setUploadUrl("");
        setFileUrl("");
      }
    } catch (error) {
      console.error("Error uploading image ", error);
    }
  };

  const onTapSubmitPhotoForm = async () => {
    await handleSubmitImage();
  };

  const handleCreateProductSystem = async () => {
    const input: CreateProductSystemInput = {
      name: productSystemName,
      // paymentMethods: paymentMethodData,
      thumbnail: photosDetails.fileUrl,
      duration: projectDuration,
      // priority: priority,
      rank: rank,
      isMaterialSelectionRequired: isMaterialSelectionRequired,
      isLaborSelectionRequired: isLaborSelectionRequired,
    };

    const success = await createProductSystem(input);
    if (success) {
      toast("Product system created successfully.", { type: "success" });
      logEvent(ITEM_CREATION_EVENTS.PRODUCT_SYSTEM_CREATED, { system_name: productSystemName, has_photo: !!photosDetails.fileUrl, timestamp: new Date().toISOString() });
      refetchProduct();
      handleDrawerClose();
      setProductSystemName("");
      setPaymentMethodData([]);
      setPhotosDetails({
        fileName: "",
        fileUrl: "",
      });
      setPriority(null);
      setProjectDuration(null);
      return;
    } else {
      console.log("Failed to create product system.");
    }
  };

  const handleUpdateProductSystem = async () => {
    const input: UpdateProductInput = {
      id: viewRowDetailsData.id,
      name: productSystemName,
      thumbnail: photosDetails.fileUrl,
      duration: projectDuration,
      rank: rank,
      isMaterialSelectionRequired: isMaterialSelectionRequired,
      isLaborSelectionRequired: isLaborSelectionRequired,
    };

    const success = await updateProductSystem(input);
    if (success) {
      toast("Product system updated successfully.", { type: "success" });
      
      const fieldsUpdated = [];
      if (productSystemName !== viewRowDetailsData.name) fieldsUpdated.push('name');
      if (photosDetails.fileUrl !== viewRowDetailsData.thumbnail) fieldsUpdated.push('thumbnail');
      if (projectDuration) fieldsUpdated.push('duration');
      if (rank) fieldsUpdated.push('rank');
      logEvent(ITEM_CREATION_EVENTS.PRODUCT_SYSTEM_UPDATED, { system_id: viewRowDetailsData.id, system_name: productSystemName, fields_updated: fieldsUpdated, timestamp: new Date().toISOString() });
      
      refetchProduct();
      handleUpdateDrawerClose();
      setProductSystemName("");
      setPhotosDetails({
        fileName: "",
        fileUrl: "",
      });
      setProjectDuration(null);
      return;
    } else {
      toast("Failed to create product system.");
    }
  };

  const onChangeProjectsStepSelectInput = async (step: any) => {
    setProjectsStep(Number(step));
  };

  const onChangeProductPrioritySelectInput = async (priorityValue: any) => {
    setPriority(Number(priorityValue));
  };

  const onChangeProductRankSelectInput = async (rankValue: any) => {
    setRank(Number(rankValue)); 
  };  

  const onChangeProjectDurationSelectInput = async (duration: any) => {
    setProjectDuration(duration);
  };

  const handleSearchIconClick = () => {
    if (inputRef && inputRef.current) {
      inputRef.current.focus();
    }
  };

  const filterProductSystem = () => {
    if (keyword.length > 0 && Array.isArray(productSystemData)) {
      return productSystemData.filter((item) => {
        const productSystemName = `${item.name}`;
        const productSystemId = `${item.id}`;
        return (
          productSystemName.toLowerCase().includes(keyword.toLowerCase()) ||
          productSystemId.toLowerCase().includes(keyword.toLowerCase())
        );
      });
    }
    return productSystemData;
  };

  const goToPreviousPage = () => {
    setPage((prevPage) => Math.max(prevPage - 1, 0));
  };

  const goToNextPage = () => {
    setPage((prevPage) =>
      Math.min(
        prevPage + 1,
        Math.ceil(filterProductSystem().length / rowsPerPage) - 1
      )
    );
  };

  const handleDrawerOpen = () => {
    setProductSystemName("");
    setProjectDuration("");
    setRank(null);
    setIsMaterialSelectionRequired(true);
    setIsLaborSelectionRequired(true);
    setPhotosDetails({ fileName: "", fileUrl: "" });
    setOpenDrawer(true);
  };

  const handleUpdateDrawerOpen = (row) => {
    setViewRowDetailsData(row);
    setProductSystemName(row.name || "");
    setProjectDuration(row.duration || "");
    setRank(row.rank || null);
    setIsMaterialSelectionRequired(row.isMaterialSelectionRequired || false);
    setIsLaborSelectionRequired(row.isLaborSelectionRequired || false);
    setPhotosDetails({ fileName: "", fileUrl: row.thumbnail });
    setOpenUpdateDrawer(true);
  };

  const handlePaymentMethodDrawerOpen = () => {
    setOpenPaymentMethodDrawer(true);
  };

  const handleDrawerClose = () => {
    setOpenDrawer(false);
  };

  const handleUpdateDrawerClose = () => {
    setOpenUpdateDrawer(false);
  };

  const handlePaymentMethodDrawerClose = () => {
    setOpenPaymentMethodDrawer(false);
  };

  const onTapSubmitForm = async () => {
    const validationRules = [
      {
        condition: !productSystemName,
        message: "Please enter product system name!",
      },
      // {
      //   condition: paymentMethodData.length === 0,
      //   message: "Please add a payment method!",
      // },
      {
        condition: !rank,
        message: "Please select a rank!",
      },
    ];

    for (const rule of validationRules) {
      if (rule.condition) {
        toast(rule.message, {
          type: "error",
          position: "top-left",
          className: "toast-message",
        });
        return;
      }
    }

    await handleCreateProductSystem();
  };
  const onTapUpdateForm = async () => {
    const validationRules = [
      {
        condition: !productSystemName,
        message: "Please enter product system name!",
      },
      {
        condition: !rank,
        message: "Please select a rank!",
      },
    ];

    for (const rule of validationRules) {
      if (rule.condition) {
        toast(rule.message, {
          type: "error",
          position: "top-left",
          className: "toast-message",
        });
        return;
      }
    }

    await handleUpdateProductSystem();
  };

  const handleAddPaymentMethod = async () => {
    const validationRules = [
      {
        condition: !paymentName,
        message: "Please enter payment name!",
      },
      {
        condition: !projectsStep,
        message: "Please enter project step!",
      },
    ];

    for (const rule of validationRules) {
      if (rule.condition) {
        toast(rule.message, {
          type: "error",
          position: "top-left",
          className: "toast-message",
        });
        return;
      }
    }

    const newPaymentMethod: PaymentMethodInput = {
      name: paymentName,
      paymentType: checkPercentage
        ? "PERCENTAGE_OF_PROJECT_TOTAL"
        : "FIXED_AMOUNT",
      amount: checkPercentage ? percentageOfProjectTotal : fixedAmount,
      stepIndex: projectsStep,
    };
    setPaymentMethodData((prevPaymentMethodData) => [
      // ...prevPaymentMethodData,
      newPaymentMethod,
    ]);
    setPaymentName("");
    setPercentageOfProjectTotal(null);
    setFixedAmount(null);
    setProjectsStep(null);
    setOpenPaymentMethodFormDrawer(false);
    toast("successfully add payment method ", { type: "success" });
  };

  const handleSavePaymentMethod = async () => {
    const validationRules = [
      {
        condition: !paymentName,
        message: "Please enter payment name!",
      },
      {
        condition: !projectsStep,
        message: "Please enter project step!",
      },
    ];

    for (const rule of validationRules) {
      if (rule.condition) {
        toast(rule.message, {
          type: "error",
          position: "top-left",
          className: "toast-message",
        });
        return;
      }
    }

    const updatedPaymentMethod: PaymentMethodInput = {
      name: paymentName,
      paymentType: checkPercentage
        ? "PERCENTAGE_OF_PROJECT_TOTAL"
        : "FIXED_AMOUNT",
      amount: checkPercentage ? percentageOfProjectTotal! : fixedAmount!,
      stepIndex: projectsStep!,
    };
    setPaymentMethodData((prevPaymentMethodData) =>
      prevPaymentMethodData.map((method, index) =>
        index === editPaymentIndex ? updatedPaymentMethod : method
      )
    );

    setPaymentName("");
    setPercentageOfProjectTotal(null);
    setFixedAmount(null);
    setProjectsStep(null);
    setOpenPaymentMethodFormDrawer(false);
    setIsEditPaymentDetails(false);
    setEditPaymentIndex(null);
  };

  const viewRowDetails = (rowData: ProductSystem) => {
    setViewRowDetailsData(rowData);
    handlePaymentMethodDrawerOpen();
  };

  const createPaymentMethod = () => {
    setCheckPercentage(false);
    setCheckFixedAmount(false);
    setFixedAmount(null);
    setPercentageOfProjectTotal(null);
    setPaymentName("");
    setProjectsStep(null);
    setOpenPaymentMethodFormDrawer(true);
  };

  const editPaymentMethod = (paymentMethod: PaymentMethodInput) => {
    const { name, stepIndex, amount, paymentType } = paymentMethod;
    setPaymentName(name || "");
    setProjectsStep(stepIndex || null);

    const isPercentage =
      paymentType === "PERCENTAGE_OF_PROJECT_TOTAL" ? true : false;

    setCheckPercentage(isPercentage);
    setCheckFixedAmount(!isPercentage);
    setPercentageOfProjectTotal(isPercentage ? amount : null);
    setFixedAmount(isPercentage ? null : amount);

    setOpenPaymentMethodFormDrawer(true);
    setIsEditPaymentDetails(true);
  };

  const createProductSystemForm = () => {
    return (
      <ProductDrawer open={openDrawer} onClose={() => handleDrawerClose()}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "24px",
            width: "100%",
          }}
        >
          <SideDrawerHeader
            handleDrawerClose={handleDrawerClose}
            labelTitle="Create new product system"
          />

          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "20px",
              width: { xs: "100%", md: "97%" },
            }}
          >
            {/* Name Field */}
            <Box sx={{ display: "flex", flexDirection: "column", gap: "8px" }}>
              <Typography
                sx={{
                  fontSize: 14,
                  fontWeight: 500,
                  color: "#1a1a2e",
                }}
              >
                Name *
              </Typography>
              <TxtInput
                placeholder="Product system name"
                onChange={setProductSystemName}
                required={true}
                value={productSystemName}
                background="inherit"
                borderColor="rgba(173, 173, 173, 1)"
                borderRadius={10}
                height={50}
              />
            </Box>

            {/* Estimated Completion Time Field */}
            <Box sx={{ display: "flex", flexDirection: "column", gap: "8px" }}>
              <Typography
                sx={{
                  fontSize: 14,
                  fontWeight: 500,
                  color: "#1a1a2e",
                }}
              >
                Estimated completion time *
              </Typography>
              <TxtInput
                placeholder="Enter estimated completion time"
                onChange={onChangeProjectDurationSelectInput}
                required={true}
                value={projectDuration}
                background="inherit"
                borderColor="rgba(173, 173, 173, 1)"
                borderRadius={10}
                height={50}
              />
            </Box>

            {/* Rank Field */}
            <Box sx={{ display: "flex", flexDirection: "column", gap: "8px" }}>
              <Typography
                sx={{
                  fontSize: 14,
                  fontWeight: 500,
                  color: "#1a1a2e",
                }}
              >
                Rank *
              </Typography>
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "row",
                  gap: "10px",
                  alignItems: "center",
                  background: "inherit",
                  borderRadius: "10px",
                  border: "1px solid rgba(173, 173, 173, 1)",
                  height: "50px",
                }}
              >
                <SelectInput
                  options={RANK_SELECT_INPUT_VALUE}
                  placeholder="Select rank"
                  onHandleChange={onChangeProductRankSelectInput}
                  value={rank}
                  required={true}
                  backgroundColor="inherit"
                />
              </Box>
            </Box>

            {/* Material Selection Required Toggle */}
            <Box sx={{ display: "flex", flexDirection: "column", gap: "8px" }}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  width: "100%",
                }}
              >
                <Typography
                  sx={{
                    fontSize: 14,
                    fontWeight: 500,
                    color: "#1a1a2e",
                  }}
                >
                  Material Selection Required
                </Typography>
                <Switch
                  checked={isMaterialSelectionRequired}
                  onChange={(e) => setIsMaterialSelectionRequired(e.target.checked)}
                  sx={{
                    "& .MuiSwitch-switchBase.Mui-checked": {
                      color: "#4b87ed",
                    },
                    "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                      backgroundColor: "#4b87ed",
                    },
                  }}
                />
              </Box>
            </Box>

            {/* Labor Selection Required Toggle */}
            <Box sx={{ display: "flex", flexDirection: "column", gap: "8px" }}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  width: "100%",
                }}
              >
                <Typography
                  sx={{
                    fontSize: 14,
                    fontWeight: 500,
                    color: "#1a1a2e",
                  }}
                >
                  Labor Selection Required
                </Typography>
                <Switch
                  checked={isLaborSelectionRequired}
                  onChange={(e) => setIsLaborSelectionRequired(e.target.checked)}
                  sx={{
                    "& .MuiSwitch-switchBase.Mui-checked": {
                      color: "#4b87ed",
                    },
                    "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                      backgroundColor: "#4b87ed",
                    },
                  }}
                />
              </Box>
            </Box>

            {/* Photo Section */}
            <Box sx={{ display: "flex", flexDirection: "column", gap: "8px" }}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                <Typography
                  sx={{
                    fontSize: 14,
                    fontWeight: 500,
                    color: "#1a1a2e",
                  }}
                >
                  Photo
                </Typography>
                <Box
                  onClick={() => setOpenPhotoFormDrawer(true)}
                  sx={{
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "24px",
                    height: "24px",
                    borderRadius: "4px",
                    border: "1px solid #d1d5db",
                    "&:hover": {
                      backgroundColor: "#f3f4f6",
                    },
                  }}
                >
                  <StandardIcon src={plusIcon} />
                </Box>
            </Box>
              {photosDetails.fileUrl === "" ? (
                <Typography
                  sx={{
                    fontSize: 13,
                    color: "#6b7280",
                  }}
                >
                  No photo of the product has been added.
                </Typography>
              ) : (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: "12px",
                    padding: "12px",
                    borderRadius: "8px",
                    border: "1px solid #e5e7eb",
                    backgroundColor: "#f9fafb",
                  }}
                >
                  <a
                    href={`${photosDetails.fileUrl}`}
                    target="_blank"
                    style={{
                      fontSize: 13,
                      color: "#4b87ed",
                      textDecoration: "none",
                      flex: 1,
                    }}
                    rel="noreferrer"
                  >
                    View File
                  </a>
                  <Box
                    onClick={() => handleDeleteDocument()}
                    sx={{
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      "&:hover": {
                        opacity: 0.7,
                      },
                    }}
                  >
                    <StandardIcon src={deleteIcon} />
                  </Box>
                </Box>
              )}
            </Box>
          </Box>

          <CancelAndSubmitButtons
            onCancel={handleDrawerClose}
            onCreate={onTapSubmitForm}
          />
        </Box>
      </ProductDrawer>
    );
  };

  const updateProductSystemForm = () => {
    return (
      <ProductDrawer
        open={openUpdateDrawer}
        onClose={() => handleUpdateDrawerClose()}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "24px",
            width: "100%",
          }}
        >
          <SideDrawerHeader
            handleDrawerClose={handleUpdateDrawerClose}
            labelTitle="Update product system"
          />

          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "20px",
              width: { xs: "100%", md: "97%" },
            }}
          >
            {/* Name Field */}
            <Box sx={{ display: "flex", flexDirection: "column", gap: "8px" }}>
              <Typography
                sx={{
                  fontSize: 14,
                  fontWeight: 500,
                  color: "#1a1a2e",
                }}
              >
                Name *
              </Typography>
              <TxtInput
                placeholder="Product system name"
                onChange={setProductSystemName}
                required={true}
                value={productSystemName}
                background="inherit"
                borderColor="rgba(173, 173, 173, 1)"
                borderRadius={10}
                height={50}
              />
            </Box>

            {/* Estimated Completion Time Field */}
            <Box sx={{ display: "flex", flexDirection: "column", gap: "8px" }}>
              <Typography
                sx={{
                  fontSize: 14,
                  fontWeight: 500,
                  color: "#1a1a2e",
                }}
              >
                Estimated completion time *
              </Typography>
              <TxtInput
                placeholder="Enter estimated completion time"
                onChange={onChangeProjectDurationSelectInput}
                required={true}
                value={projectDuration}
                background="inherit"
                borderColor="rgba(173, 173, 173, 1)"
                borderRadius={10}
                height={50}
              />
            </Box>

            {/* Rank Field */}
            <Box sx={{ display: "flex", flexDirection: "column", gap: "8px" }}>
              <Typography
                sx={{
                  fontSize: 14,
                  fontWeight: 500,
                  color: "#1a1a2e",
                }}
              >
                Rank *
              </Typography>
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "row",
                  gap: "10px",
                  alignItems: "center",
                  background: "inherit",
                  borderRadius: "10px",
                  border: "1px solid rgba(173, 173, 173, 1)",
                  height: "50px",
                }}
              >
                <SelectInput
                  options={RANK_SELECT_INPUT_VALUE}
                  placeholder="Select rank"
                  onHandleChange={onChangeProductRankSelectInput}
                  value={rank}
                  required={true}
                  backgroundColor="inherit"
                />
              </Box>
            </Box>

            {/* Material Selection Required Toggle */}
            <Box sx={{ display: "flex", flexDirection: "column", gap: "8px" }}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  width: "100%",
                }}
              >
                <Typography
                  sx={{
                    fontSize: 14,
                    fontWeight: 500,
                    color: "#1a1a2e",
                  }}
                >
                  Material Selection Required
                </Typography>
                <Switch
                  checked={isMaterialSelectionRequired}
                  onChange={(e) => setIsMaterialSelectionRequired(e.target.checked)}
                  sx={{
                    "& .MuiSwitch-switchBase.Mui-checked": {
                      color: "#4b87ed",
                    },
                    "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                      backgroundColor: "#4b87ed",
                    },
                  }}
                />
              </Box>
            </Box>

            {/* Labor Selection Required Toggle */}
            <Box sx={{ display: "flex", flexDirection: "column", gap: "8px" }}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  width: "100%",
                }}
              >
                <Typography
                  sx={{
                    fontSize: 14,
                    fontWeight: 500,
                    color: "#1a1a2e",
                  }}
                >
                  Labor Selection Required
                </Typography>
                <Switch
                  checked={isLaborSelectionRequired}
                  onChange={(e) => setIsLaborSelectionRequired(e.target.checked)}
                  sx={{
                    "& .MuiSwitch-switchBase.Mui-checked": {
                      color: "#4b87ed",
                    },
                    "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                      backgroundColor: "#4b87ed",
                    },
                  }}
                />
              </Box>
            </Box>

            {/* Photo Section */}
            <Box sx={{ display: "flex", flexDirection: "column", gap: "8px" }}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                <Typography
                  sx={{
                    fontSize: 14,
                    fontWeight: 500,
                    color: "#1a1a2e",
                  }}
                >
                  Photo
                </Typography>
                <Box
                  onClick={() => setOpenPhotoFormDrawer(true)}
                  sx={{
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "24px",
                    height: "24px",
                    borderRadius: "4px",
                    border: "1px solid #d1d5db",
                    "&:hover": {
                      backgroundColor: "#f3f4f6",
                    },
                  }}
                >
                  <StandardIcon src={plusIcon} />
                </Box>
              </Box>
              {photosDetails.fileUrl || viewRowDetailsData?.thumbnail ? (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: "12px",
                    padding: "12px",
                    borderRadius: "8px",
                    border: "1px solid #e5e7eb",
                    backgroundColor: "#f9fafb",
                  }}
                >
                  <a
                    href={
                      photosDetails.fileUrl || viewRowDetailsData?.thumbnail
                    }
                    target="_blank"
                    style={{
                      fontSize: 13,
                      color: "#4b87ed",
                      textDecoration: "none",
                      flex: 1,
                    }}
                    rel="noreferrer"
                  >
                    View File
                  </a>
                  <Box
                    onClick={() => handleDeleteDocument()}
                    sx={{
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      "&:hover": {
                        opacity: 0.7,
                      },
                    }}
                  >
                    <StandardIcon src={deleteIcon} />
                  </Box>
                </Box>
              ) : (
                <Typography
                  sx={{
                    fontSize: 13,
                    color: "#6b7280",
                  }}
                >
                  No photo of the product has been added. Please upload one.
                </Typography>
              )}
            </Box>
          </Box>

          <CancelAndSubmitButtons
            onCancel={handleUpdateDrawerClose}
            onCreate={onTapUpdateForm}
            submitText="Update"
          />
        </Box>
      </ProductDrawer>
    );
  };

  const createPaymentMethodFormDrawer = (paymentData = null) => {
    return (
      <ProductDrawer
        open={openPaymentMethodFormDrawer}
        onClose={() => setOpenPaymentMethodFormDrawer(false)}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: { xs: "20px", md: "24px" },
            width: "100%",
          }}
        >
          <SideDrawerHeader
            handleDrawerClose={() => setOpenPaymentMethodFormDrawer(false)}
            labelTitle={
              isEditPaymentDetails
                ? "Edit Payment Method"
                : "Create Product System Payment"
            }
          />

          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "20px",
              width: "100%",
            }}
          >
            {/* Name Field */}
            <Box>
              <FormTitleTypography sx={{ mb: 1 }}>Name *</FormTitleTypography>
              <TxtInput
                placeholder="Name of payment"
                onChange={setPaymentName}
                required={true}
                value={paymentName}
                background="inherit"
                borderColor="rgba(173, 173, 173, 1)"
                borderRadius={10}
                height={50}
                width="100%"
              />
            </Box>

            {/* Payment Type Section */}
            <Box>
              <FormTitleTypography sx={{ mb: 1 }}>
                Payment Type *
              </FormTitleTypography>

              {/* Percentage Option */}
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "12px",
                  p: "12px",
                  borderRadius: "8px",
                  border: checkPercentage
                    ? "2px solid #4b87ed"
                    : "1px solid #e5e7eb",
                  backgroundColor: checkPercentage ? "#f0f7ff" : "white",
                  mb: "12px",
                  cursor: "pointer",
                }}
                onClick={() => {
                  setCheckPercentage(true);
                  setCheckFixedAmount(false);
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    gap: "10px",
                  }}
                >
                  <ChkInputBox
                    onChange={(value) => {
                      setCheckPercentage(value);
                      setCheckFixedAmount(!value);
                    }}
                    placeholder=""
                    width={50}
                    background="inherit"
                    checked={checkPercentage}
                  />
                  <Typography sx={{ fontSize: 14, fontWeight: 500 }}>
                    Percentage of Project Total
                  </Typography>
                </Box>

                {checkPercentage && (
                  <Box sx={{ pl: "60px", pr: "10px" }}>
                    <TxtInput
                      type="number"
                      placeholder="Enter Percentage"
                      onChange={setPercentageOfProjectTotal}
                      value={percentageOfProjectTotal}
                      marginBottom={0}
                      marginTop={0}
                      background="inherit"
                      borderColor="rgba(173, 173, 173, 1)"
                      borderRadius={10}
                      disable={!checkPercentage}
                      width="100%"
                    />
                  </Box>
                )}
              </Box>

              {/* Fixed Amount Option */}
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "12px",
                  p: "12px",
                  borderRadius: "8px",
                  border: checkFixedAmount
                    ? "2px solid #4b87ed"
                    : "1px solid #e5e7eb",
                  backgroundColor: checkFixedAmount ? "#f0f7ff" : "white",
                  cursor: "pointer",
                }}
                onClick={() => {
                  setCheckFixedAmount(true);
                  setCheckPercentage(false);
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    gap: "10px",
                  }}
                >
                  <ChkInputBox
                    onChange={(value) => {
                      setCheckFixedAmount(value);
                      setCheckPercentage(!value);
                    }}
                    placeholder=""
                    width={50}
                    background="inherit"
                    marginBottom={0}
                    marginTop={0}
                    checked={checkFixedAmount}
                  />
                  <Typography sx={{ fontSize: 14, fontWeight: 500 }}>
                    Fixed Amount
                  </Typography>
                </Box>

                {checkFixedAmount && (
                  <Box sx={{ pl: "60px", pr: "10px" }}>
                    <TxtInput
                      type="number"
                      placeholder="Enter Amount"
                      onChange={setFixedAmount}
                      value={fixedAmount}
                      marginBottom={0}
                      marginTop={0}
                      background="inherit"
                      borderColor="rgba(173, 173, 173, 1)"
                      borderRadius={10}
                      disable={!checkFixedAmount}
                      width="100%"
                    />
                  </Box>
                )}
              </Box>
            </Box>

            {/* Project Step Field */}
            <Box>
              <FormTitleTypography sx={{ mb: 1 }}>
                Project Step *
              </FormTitleTypography>
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "row",
                  gap: "10px",
                  alignItems: "center",
                  background: "inherit",
                  borderRadius: "10px",
                  border: "1px solid rgba(173, 173, 173, 1)",
                  height: "50px",
                  px: "10px",
                }}
              >
                <SelectInput
                  options={PROJECTS_STEP}
                  onHandleChange={onChangeProjectsStepSelectInput}
                  value={projectsStep}
                  required={true}
                  backgroundColor="inherit"
                />
              </Box>
            </Box>
          </Box>

          <CancelAndSubmitButtons
            onCancel={() => setOpenPaymentMethodFormDrawer(false)}
            onCreate={
              isEditPaymentDetails
                ? handleSavePaymentMethod
                : handleAddPaymentMethod
            }
            submitText={isEditPaymentDetails ? "Save" : "Create"}
          />
        </Box>
      </ProductDrawer>
    );
  };

  const ProductSystemPaymentTable = ({ value }: { value: any[] }) => {
    return (
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          paddingY: "10px",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <LeadsTableHeaderCard
          headers={PAYMENT_METHOD_TABLE_HEADER_LIST}
          fontSize="12px"
        />

        {value.map((row, rowIndex) => (
          <PaymentMethodWithoutHeader
            key={`product system ${rowIndex}`}
            bodyContent={[
              {
                text: `${rowIndex + 1}`,
                width: "5%",
                fontSize: "14px",
              },
              {
                text: `${row.name}`,
                width: "30%",
                fontSize: "14px",
              },
              {
                text:
                  row.paymentType === "PERCENTAGE_OF_PROJECT_TOTAL" ? (
                    `${row.percent}%`
                  ) : (
                    <NumericFormat
                      style={{
                        width: "100%",
                        height: "100%",
                      }}
                      value={row.amount}
                      prefix="$"
                      thousandSeparator
                    />
                  ),
                width: "50%",
              },
              {
                text: `${row.stepNumber}`,
                width: "15%",
                fontSize: "14px",
              },
            ]}
          />
        ))}
      </Box>
    );
  };

  const showProductSystemDetails = () => {
    return (
      <ViewRowDetailsDrawer
        openDrawer={openPaymentMethodDrawer}
        handleDrawerClose={handlePaymentMethodDrawerClose}
        rowDetailsData={viewRowDetailsData}
        labelTitle="Product System details"
        rowArrayTableComponent={(value: any, key?: string) => (
          <DisplayPhoto value={value} key={key} />
        )}
        detailsOfRowToBeDisplay={PRODUCT_SYSTEM_DRAWER_DETAILS}
        rowArrayTableComponentTwo={(value: any[], key?: string) => (
          <ProductSystemPaymentTable value={value} key={key} />
        )}
      />
    );
  };

  const createPhotoFormDrawer = (PhotoData = null) => {
    return (
      <MaterialItemsDrawer
        open={openPhotoFormDrawer}
        onClose={() => setOpenPhotoFormDrawer(false)}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "24px",
            width: "100%",
          }}
        >
          <SideDrawerHeader
            handleDrawerClose={() => setOpenPhotoFormDrawer(false)}
            labelTitle="Upload product system photo"
          />

          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "12px",
            }}
          >
            <Typography
              sx={{
                fontSize: 14,
                fontWeight: 500,
                color: "#1a1a2e",
              }}
            >
              Upload Photo
            </Typography>
            <Box
              onClick={() => {
                if (fileRef.current) {
                  fileRef.current.click();
                }
              }}
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                gap: "8px",
                padding: "24px",
                border: uploadUrl === "" ? "2px dashed #d1d5db" : "2px solid #4b87ed",
                borderRadius: "8px",
                backgroundColor: uploadUrl === "" ? "#f9fafb" : "#f0f7ff",
                cursor: "pointer",
                transition: "all 0.2s",
                "&:hover": {
                  borderColor: uploadUrl === "" ? "#9ca3af" : "#3b72d6",
                  backgroundColor: uploadUrl === "" ? "#f3f4f6" : "#e0f0ff",
                },
              }}
            >
              <input
                type="file"
                id="file"
                ref={fileRef}
                onChange={() => {
                  if (uploadUrl === "") {
                    getUploadUrl();
                  }
                }}
                accept={"image/png, image/jpeg, image/jpg"}
                style={{
                  display: "none",
                }}
              />
              <FileOpen
                titleAccess="Select File"
                style={{
                  width: 32,
                  height: 32,
                  color: uploadUrl === "" ? "#6b7280" : "#4b87ed",
                }}
              />
              <Typography
                sx={{
                  fontSize: 13,
                  color: uploadUrl === "" ? "#6b7280" : "#4b87ed",
                  fontWeight: 500,
                }}
              >
                {uploadUrl === "" ? "Click to select file" : "File selected"}
              </Typography>
              <Typography
                sx={{
                  fontSize: 12,
                  color: "#9ca3af",
                }}
              >
                PNG, JPG (max. 5MB)
              </Typography>
            </Box>
          </Box>
        </Box>

        <CancelAndSubmitButtons
          onCancel={handlePhotoDrawerClose}
          onCreate={onTapSubmitPhotoForm}
          submitText="Add photo"
          isDisabled={uploadUrl === "" ? true : false}
          bgColor={uploadUrl === "" ? AppCSS.GRAY_MILD : AppCSS.GLAS_GREEN}
        />
      </MaterialItemsDrawer>
    );
  };

  const ProductsSystemTable = () => {
    const paginatedData = filterProductSystem().slice(
      page * rowsPerPage,
      page * rowsPerPage + rowsPerPage
    );
    const totalPages = Math.ceil(filterProductSystem().length / rowsPerPage);

    return (
      <Box sx={{ width: "100%" }}>
        {/* Search and Create Button */}
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            justifyContent: "space-between",
            alignItems: { xs: "stretch", md: "center" },
            gap: 2,
            mb: 3,
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              backgroundColor: "white",
              border: "1px solid #e0e0e0",
              borderRadius: "8px",
              height: "44px",
              width: { xs: "100%", md: "320px" },
              transition: "border-color 0.2s, box-shadow 0.2s",
              "&:focus-within": {
                borderColor: "#4b87ed",
                boxShadow: "0 0 0 3px rgba(75, 135, 237, 0.1)",
              },
            }}
          >
            <Box
              component="img"
              src={searchIcon}
              sx={{ width: 16, height: 16, cursor: "pointer", margin: "0 12px" }}
              onClick={handleSearchIconClick}
            />
            <TxtInput
              placeholder="Search product systems"
              onChange={setKeyword}
              inputRef={inputRef}
              background="white"
              width="100%"
            />
          </Box>

          {permissions && (
            <Box
              component="button"
              onClick={handleDrawerOpen}
              sx={{
                padding: "10px 20px",
                borderRadius: "8px",
                fontSize: "14px",
                fontWeight: 500,
                cursor: "pointer",
                transition: "all 0.2s",
                backgroundColor: "#4b87ed",
                color: "white",
                border: "none",
                whiteSpace: "nowrap",
                "&:hover": {
                  backgroundColor: "#3a6fd8",
                },
              }}
            >
              + Create new system
            </Box>
          )}
        </Box>

        {/* Table */}
        <Box
          sx={{
            width: "100%",
            backgroundColor: "white",
            borderRadius: "12px",
            boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
            overflow: "hidden",
          }}
        >
          {/* Desktop Table Header */}
          <Box
            sx={{
              display: { xs: "none", md: "flex" },
              padding: "14px 20px",
              backgroundColor: "#f3f4f6",
              borderBottom: "1px solid #e5e7eb",
              fontWeight: 600,
              fontSize: 12,
              color: "#6b7280",
              textTransform: "uppercase",
              alignItems: "center",
            }}
          >
            <Box sx={{ width: "10%", minWidth: "60px" }}>ID</Box>
            <Box sx={{ width: "35%", minWidth: "150px" }}>Name</Box>
            <Box sx={{ width: "20%", minWidth: "100px", textAlign: "center" }}>Publish</Box>
            <Box sx={{ width: "35%", minWidth: "180px", textAlign: "right" }}>Actions</Box>
          </Box>

          {/* Table Body */}
          {filterProductSystem().length === 0 ? (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                padding: "48px 24px",
                textAlign: "center",
              }}
            >
              <Typography sx={{ fontSize: 15, color: "#6b7280", margin: 0 }}>
                No products available
              </Typography>
            </Box>
          ) : (
            paginatedData.map((row, rowIndex) => (
              <Box
                key={`product-system-${rowIndex}`}
                sx={{
                  display: "flex",
                  flexDirection: { xs: "column", md: "row" },
                  alignItems: { xs: "flex-start", md: "center" },
                  padding: { xs: "14px 16px", md: "14px 20px" },
                  borderBottom: "1px solid #f0f0f0",
                  gap: { xs: 1, md: 0 },
                  width: "100%",
                  "&:hover": {
                    backgroundColor: "#f8f9fa",
                  },
                  "&:last-child": {
                    borderBottom: "none",
                  },
                }}
              >
                {/* ID */}
                <Box sx={{ width: { xs: "100%", md: "10%" }, minWidth: { md: "60px" } }}>
                  <Typography
                    sx={{
                      display: { xs: "block", md: "none" },
                      fontSize: 11,
                      fontWeight: 500,
                      color: "#9ca3af",
                      textTransform: "uppercase",
                      letterSpacing: 0.5,
                      marginBottom: "2px",
                    }}
                  >
                    ID
                  </Typography>
                  <Typography sx={{ fontSize: 14, fontWeight: 500, color: "#1a1a2e" }}>
                    {row.id}
                  </Typography>
                </Box>

                {/* Name */}
                <Box sx={{ width: { xs: "100%", md: "35%" }, minWidth: { md: "150px" } }}>
                  <Typography
                    sx={{
                      display: { xs: "block", md: "none" },
                      fontSize: 11,
                      fontWeight: 500,
                      color: "#9ca3af",
                      textTransform: "uppercase",
                      letterSpacing: 0.5,
                      marginBottom: "2px",
                    }}
                  >
                    Name
                  </Typography>
                  <Typography sx={{ fontSize: 14, color: "#374151" }}>
                    {row.name}
                  </Typography>
                </Box>

                {/* Publish */}
                <Box
                  sx={{
                    width: { xs: "100%", md: "20%" },
                    minWidth: { md: "100px" },
                    display: "flex",
                    alignItems: "center",
                    justifyContent: { xs: "flex-start", md: "center" },
                  }}
                >
                  <Typography
                    sx={{
                      display: { xs: "block", md: "none" },
                      fontSize: 11,
                      fontWeight: 500,
                      color: "#9ca3af",
                      textTransform: "uppercase",
                      letterSpacing: 0.5,
                      marginRight: "8px",
                    }}
                  >
                    Publish:
                  </Typography>
                  {permissions && (
                    <Switch
                      checked={!row.archived}
                      onChange={() => handleTogglePublish(row)}
                      sx={{
                        "& .MuiSwitch-switchBase.Mui-checked": {
                          color: "#4b87ed",
                        },
                        "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                          backgroundColor: "#4b87ed",
                        },
                      }}
                    />
                  )}
                </Box>

                {/* Actions */}
                <Box
                  sx={{
                    width: { xs: "100%", md: "35%" },
                    minWidth: { md: "180px" },
                    display: "flex",
                    justifyContent: { xs: "flex-start", md: "flex-end" },
                    gap: 1,
                    flexWrap: "wrap",
                    marginLeft: { md: "auto" },
                  }}
                >
                  <Box
                    component="button"
                    onClick={() => viewRowDetails(row)}
                    sx={{
                      padding: "8px 16px",
                      borderRadius: "6px",
                      fontSize: "13px",
                      fontWeight: 500,
                      cursor: "pointer",
                      transition: "all 0.2s",
                      backgroundColor: "#e5e7eb",
                      color: "#374151",
                      border: "none",
                      "&:hover": {
                        backgroundColor: "#d1d5db",
                      },
                    }}
                  >
                    View
                  </Box>
                  {permissions && (
                    <Box
                      component="button"
                      onClick={() => handleUpdateDrawerOpen(row)}
                      sx={{
                        padding: "8px 16px",
                        borderRadius: "6px",
                        fontSize: "13px",
                        fontWeight: 500,
                        cursor: "pointer",
                        transition: "all 0.2s",
                        backgroundColor: "#e5e7eb",
                        color: "#374151",
                        border: "none",
                        "&:hover": {
                          backgroundColor: "#d1d5db",
                        },
                      }}
                    >
                      Edit
                    </Box>
                  )}
                </Box>
              </Box>
            ))
          )}

          {/* Pagination */}
          {filterProductSystem().length > 0 && totalPages > 1 && (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: { xs: "center", md: "flex-end" },
                padding: "14px 20px",
                gap: 1,
                borderTop: "1px solid #f0f0f0",
                backgroundColor: "#fafafa",
              }}
            >
              <Box
                component="button"
                onClick={goToPreviousPage}
                disabled={page === 0}
                sx={{
                  px: 2,
                  py: 1,
                  border: "none",
                  borderRadius: "6px",
                  backgroundColor: page === 0 ? "#f3f4f6" : "#e5e7eb",
                  color: page === 0 ? "#9ca3af" : "#374151",
                  fontSize: 13,
                  fontWeight: 500,
                  cursor: page === 0 ? "not-allowed" : "pointer",
                  "&:hover": page === 0 ? {} : { backgroundColor: "#d1d5db" },
                }}
              >
                ← Prev
              </Box>
              <Typography sx={{ fontSize: 14, color: "#6b7280", margin: "0 8px" }}>
                Page {page + 1} of {totalPages}
              </Typography>
              <Box
                component="button"
                onClick={goToNextPage}
                disabled={page >= totalPages - 1}
                sx={{
                  px: 2,
                  py: 1,
                  border: "none",
                  borderRadius: "6px",
                  backgroundColor: page >= totalPages - 1 ? "#f3f4f6" : "#e5e7eb",
                  color: page >= totalPages - 1 ? "#9ca3af" : "#374151",
                  fontSize: 13,
                  fontWeight: 500,
                  cursor: page >= totalPages - 1 ? "not-allowed" : "pointer",
                  "&:hover": page >= totalPages - 1 ? {} : { backgroundColor: "#d1d5db" },
                }}
              >
                Next →
              </Box>
            </Box>
          )}
        </Box>
      </Box>
    );
  };

  const ProductsSystemContainer = () => {
    return (
      <Box sx={{ width: "100%" }}>
        {Array.isArray(productSystemData) && ProductsSystemTable()}
        {createProductSystemForm()}
        {updateProductSystemForm()}
        {createPaymentMethodFormDrawer()}
        {showProductSystemDetails()}
        {createPhotoFormDrawer()}
      </Box>
    );
  };

  return <>{ProductsSystemContainer()}</>;
};
